export default __webpack_public_path__ + "static/media/WordArt.74756704.png";